import * as React from 'react'
import Button from '@mui/material/Button'
import AddImportUtilityDrawer from '../../AddImportUtilityDrawer/AddImportUtilityDrawer'
import { useDialogState } from '@user/utils/useDialogState'
import { ImportUtilityModel } from '../../AddImportUtilityDrawer/typings'

type Props = {
  onDrawerSave: (model: ImportUtilityModel) => void
}
export function TitleContent(props: Props) {
  const { onDrawerSave } = props
  const [open, onOpen, onClose] = useDialogState()

  return (
    <>
      <Button onClick={onOpen} variant="contained">
        New Import
      </Button>
      <AddImportUtilityDrawer
        open={open}
        onClose={onClose}
        onSave={onDrawerSave}
      />
    </>
  )
}
